import {
  BOARD_GROUP_PREVISTO_HOJE,
  BOARD_GROUP_PREVISTAS_AMANHA,
  BOARD_GROUP_FUTURA,
  isBoardLiveServiceGroup,
} from '../constants/boardGroups';

/** Sessões longas: virtualizar. Live (deslocamento/serviço): nunca. */
export const TECHNICIAN_LONG_SESSION_GROUPS = [
  BOARD_GROUP_PREVISTO_HOJE,
  BOARD_GROUP_PREVISTAS_AMANHA,
  BOARD_GROUP_FUTURA,
];

export const TECHNICIAN_SESSION_VIRTUAL_ENABLED = true;
export const TECHNICIAN_SESSION_VIRTUAL_MIN = 8;

/** Altura máx. do container da sessão quando virtualiza (scroll interno). */
export const TECHNICIAN_SESSION_VIRTUAL_VIEWPORT_PX = 420;

const CITY_HEADER_PX = 22;
const ORDER_ROW_PX = 22;
const FORECAST_HEADER_PX = 28;
const FORECAST_MARGIN_PX = 6;

export function isTechnicianLongSessionGroup(groupName) {
  return TECHNICIAN_LONG_SESSION_GROUPS.includes(groupName);
}

export function shouldVirtualizeTechnicianSession(groupName, itemCount) {
  if (!TECHNICIAN_SESSION_VIRTUAL_ENABLED) return false;
  if (isBoardLiveServiceGroup(groupName)) return false;
  if (!isTechnicianLongSessionGroup(groupName)) return false;
  return Number(itemCount) >= TECHNICIAN_SESSION_VIRTUAL_MIN;
}

/** Item = { ordens } (cidade) */
export function estimateTechnicianCityBlockSize(item) {
  const n = Array.isArray(item?.ordens) ? item.ordens.length : 0;
  return CITY_HEADER_PX + Math.max(1, n) * ORDER_ROW_PX + 4;
}

/** Item = { orders } (bloco de previsão FUTURA) — estima por nº de OS. */
export function estimateTechnicianForecastBlockSize(item) {
  const n = Array.isArray(item?.orders) ? item.orders.length : 0;
  const citiesApprox = Math.max(1, Math.ceil(n / 3));
  return FORECAST_HEADER_PX + citiesApprox * (CITY_HEADER_PX + 3 * ORDER_ROW_PX) + FORECAST_MARGIN_PX;
}
